import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Shops from './pages/Shops';
import ShopCategories from './pages/ShopCategories';
import ProductCategories from './pages/ProductCategories';
import ProductBrands from './pages/ProductBrands';
import AvailabilityRules from './pages/AvailabilityRules';
import Products from './pages/Products';
import ShopProducts from './pages/ShopProducts';
import AddShopProduct from './pages/AddShopProduct';
import ShopLogins from './pages/ShopLogins';
import CreateOrder from './pages/CreateOrder';
import Orders from './pages/Orders';
import OrderDetails from './pages/OrderDetails';
import EditOrder from './pages/EditOrder';
import Customers from './pages/Customers';
import ContactEnquiries from './pages/ContactEnquiries';
import DeliveryCharges from './pages/DeliveryCharges';
import DeliveryExecutives from './pages/DeliveryExecutives';
import DeliveryExecutiveLogins from './pages/DeliveryExecutiveLogins';
import DeliverySettlements from './pages/DeliverySettlements';
import ShopSettlements from './pages/ShopSettlements';
import GenerateShopSettlement from './pages/GenerateShopSettlement';
import QuickOrderSuggestions from './pages/QuickOrderSuggestions';
import OrderStatusReport from './pages/OrderStatusReport';
import ShopOrderReport from './pages/ShopOrderReport';
import MenuSections from './pages/MenuSections';
import ExpenseTypes from './pages/ExpenseTypes';
import Expenses from './pages/Expenses';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('ataservtoken');
  return token ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <>
      <Router>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<Login />} />

          

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/shops"
            element={
              <PrivateRoute>
                <Shops />
              </PrivateRoute>
            }
          />
          <Route
            path="/shop-categories"
            element={
              <PrivateRoute>
                <ShopCategories />
              </PrivateRoute>
            }
          />
          <Route
            path="/product-categories"
            element={
              <PrivateRoute>
                <ProductCategories />
              </PrivateRoute>
            }
          />
          <Route
            path="/product-brands"
            element={
              <PrivateRoute>
                <ProductBrands />
              </PrivateRoute>
            }
          />
          <Route
            path="/availability-rules"
            element={
              <PrivateRoute>
                <AvailabilityRules />
              </PrivateRoute>
            }
          />
          <Route
            path="/products"
            element={
              <PrivateRoute>
                <Products />
              </PrivateRoute>
            }
          />
          <Route
            path="/shop-products"
            element={
              <PrivateRoute>
                <ShopProducts />
              </PrivateRoute>
            }
          />
          <Route
            path="/shop-menu-sections"
            element={
              <PrivateRoute>
                <MenuSections />
              </PrivateRoute>
            }
          />
          <Route
            path="/shop-logins"
            element={
              <PrivateRoute>
                <ShopLogins />
              </PrivateRoute>
            }
          />
          <Route
            path="/shop-products/add"
            element={
              <PrivateRoute>
                <AddShopProduct />
              </PrivateRoute>
            }
          />
          <Route
            path="/orders/create"
            element={
              <PrivateRoute>
                <CreateOrder />
              </PrivateRoute>
            }
          />
          <Route
            path="/orders/:id/edit"
            element={
              <PrivateRoute>
                <EditOrder />
              </PrivateRoute>
            }
          />
          <Route
            path="/orders/:id"
            element={
              <PrivateRoute>
                <OrderDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <PrivateRoute>
                <Orders />
              </PrivateRoute>
            }
          />
          <Route
            path="/orders/reports/status"
            element={
              <PrivateRoute>
                <OrderStatusReport />
              </PrivateRoute>
            }
          />
          <Route
            path="/orders/reports/shops"
            element={
              <PrivateRoute>
                <ShopOrderReport />
              </PrivateRoute>
            }
          />
          <Route
            path="/customers"
            element={
              <PrivateRoute>
                <Customers />
              </PrivateRoute>
            }
          />
          <Route
            path="/contact-enquiries"
            element={
              <PrivateRoute>
                <ContactEnquiries />
              </PrivateRoute>
            }
          />
            <Route
              path="/delivery-executives"
              element={
                <PrivateRoute>
                  <DeliveryExecutives />
                </PrivateRoute>
              }
            />
            <Route
              path="/delivery-executive-logins"
              element={
                <PrivateRoute>
                  <DeliveryExecutiveLogins />
                </PrivateRoute>
              }
            />
            <Route
              path="/delivery-charges"
              element={
                <PrivateRoute>
                  <DeliveryCharges />
                </PrivateRoute>
              }
            />
          <Route
            path="/delivery-settlements"
            element={
              <PrivateRoute>
                <DeliverySettlements />
              </PrivateRoute>
            }
          />
          <Route
            path="/shop-settlements"
            element={
              <PrivateRoute>
                <ShopSettlements />
              </PrivateRoute>
            }
          />
          <Route
            path="/shop-settlements/generate"
            element={
              <PrivateRoute>
                <GenerateShopSettlement />
              </PrivateRoute>
            }
          />
          <Route
            path="/quick-order-suggestions"
            element={
              <PrivateRoute>
                <QuickOrderSuggestions />
              </PrivateRoute>
            }
          />
          <Route
            path="/expense-types"
            element={
              <PrivateRoute>
                <ExpenseTypes />
              </PrivateRoute>
            }
          />
          <Route
            path="/expenses"
            element={
              <PrivateRoute>
                <Expenses />
              </PrivateRoute>
            }
          />
          <Route
            path="/quick-order-suggestions/add-option"
            element={
              <PrivateRoute>
                <QuickOrderSuggestions />
              </PrivateRoute>
            }
          />
          <Route
            path="/quick-order-suggestions/edit-option"
            element={
              <PrivateRoute>
                <QuickOrderSuggestions />
              </PrivateRoute>
            }
          />

          {/* Default Redirect */}
          <Route path="*" element={<Navigate to="/shops" />} />
        </Routes>
      </Router>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
